<template>
    <v-container grid-list-lg>
        <template>
            <v-layout row wrap align-center>
                <v-flex xs6>
                    <slot name="foundProducts" />
                </v-flex>
                <v-flex xs6 md2 offset-md4 text-xs-right>
                    <slot name="sortingSelector" />
                    <slot name="filterButton" />
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-flex md3>
                    <slot name="desktopFilters" />
                </v-flex>

                <v-flex xs12 md9>
                    <slot name="categoryTextTop" />
                    <slot name="searchResults" />
                </v-flex>

                <v-flex xs12 text-xs-center>
                    <slot name="pagination" />
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-flex md3 />
                <v-flex xs12 md9>
                    <slot name="categoryTextBottom" />
                </v-flex>
            </v-layout>

            <slot name="mobileFilters" />
        </template>
    </v-container>
</template>

<script>
export default {
    name: 'SearchResultsTemplate',
};
</script>
